import { useRef } from "react";
import { PropTypes } from "prop-types";

import { CONTACT_STEP } from "../helpers/constants";
import { useCompanyInfo } from "../hooks/useCompanyInfo";
import { usePathname } from "../hooks/usePathname";
import { useUpdateEffect } from "../hooks/useUpdateEffect";
import { Container } from "./Container";
import { MovingAssistance } from "./MovingAssistance";
import { QuoteCallout } from "./QuoteCallout";
import { ShortBenefitsList } from "./ShortBenefitsList";
import { ShortCoupon } from "./ShortCoupon";
import { StepsBadge } from "./StepsBadge";
import { StepsMeter } from "./StepsMeter";

export const FormLayout = ({ children }) => {
	const { companyName } = useCompanyInfo();
	const pathname = usePathname();

	const ref = useRef(null);

	useUpdateEffect(() => {
		if (ref.current === null) return;
		if (pathname !== CONTACT_STEP) return;

		ref.current.scrollIntoView({ behavior: "smooth" });
	}, [pathname]);

	return (
		<>
			{/* No. of Step Meter */}
			<StepsMeter />
			<Container
				as="main"
				className="tw:flex tw:h-full tw:w-full tw:flex-col tw:justify-between tw:gap-4 tw:pt-8 tw:pb-[28px] tw:md:gap-6 tw:md:pb-10 tw:lg:flex-row tw:lg:gap-[30px] tw:lg:py-[80px]"
			>
				<h1 className="tw:sr-only">{companyName}</h1>
				{/* Content */}
				<div className="tw:relative tw:flex tw:w-full tw:max-w-full tw:flex-col tw:justify-between tw:md:flex-row tw:lg:max-w-[335px] tw:lg:flex-col tw:lg:justify-start tw:xl:max-w-[445px]">
					<MovingAssistance />
					<div className="tw:flex tw:flex-col">
						<div className="tw:relative tw:mb-0 tw:max-w-full tw:shadow-[0px_8px_24px_0px_rgba(23,23,23,0.06)] tw:md:mb-4 tw:md:max-w-[328px]">
							<div className="tw:relative tw:block tw:rounded-t-2xl tw:border-4 tw:border-solid tw:border-white tw:md:hidden">
								<QuoteCallout />
							</div>
							<ShortCoupon />
						</div>
						<div className="tw:relative tw:hidden tw:max-w-[328px] tw:shadow-[0px_8px_24px_0px_rgba(23,23,23,0.06)] tw:md:block">
							<ShortBenefitsList />
						</div>
					</div>
				</div>
				{/* Form */}
				<div className="tw:flex tw:w-full tw:flex-col">
					<div className="tw:mb-4 tw:hidden tw:rounded-[32px] tw:border-4 tw:border-solid tw:border-white tw:bg-white tw:shadow-[0px_8px_24px_0px_rgba(23,23,23,0.06)] tw:md:block">
						<QuoteCallout />
					</div>
					<div
						ref={ref}
						className="tw:relative tw:w-full tw:rounded-2xl tw:bg-white tw:px-4 tw:pt-8 tw:pb-4 tw:shadow-[0px_8px_24px_0px_rgba(23,23,23,0.06)] tw:md:rounded-[32px] tw:md:p-10"
					>
						<StepsBadge />
						{children}
					</div>
				</div>
				<div className="tw:block tw:md:hidden">
					<ShortBenefitsList />
				</div>
			</Container>
		</>
	);
};

FormLayout.propTypes = {
	children: PropTypes.node,
};
